function updateServiceWorker(releaseId) {
  if (!("serviceWorker" in navigator)) return;
  const message = { type: "AULYN_RELEASE_REFRESH", releaseId };
  navigator.serviceWorker.controller?.postMessage(message);
  if (typeof navigator.serviceWorker.getRegistration !== "function") return;
  void navigator.serviceWorker.getRegistration().then(async (registration) => {
    registration?.waiting?.postMessage({ type: "AULYN_SKIP_WAITING" });
    await registration?.update();
    registration?.waiting?.postMessage({ type: "AULYN_SKIP_WAITING" });
  }).catch(() => undefined);
}

function refreshNonce() {
  return typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function isInstalledPwa(browserWindow = window, browserNavigator = navigator) {
  return Boolean(
    browserWindow.matchMedia?.("(display-mode: standalone)").matches ||
    browserNavigator.standalone,
  );
}

export function hardRefresh(releaseId = "") {
  const normalizedReleaseId = releaseId.trim();
  const url = new URL(window.location.href);
  url.searchParams.set("_aulyn_refresh", refreshNonce());
  if (normalizedReleaseId) url.searchParams.set("_aulyn_release", normalizedReleaseId);
  updateServiceWorker(normalizedReleaseId);
  window.location.replace(url.href);
}
